module.exports = {
  primary: '#009688',
  secondary: '#FFC107',
  accent: '#40C4FF',
};
